import { NOTICE_FIRST_OPTIONS } from '../NOTICE_FIRST_OPTIONS';
import { NoticeFirstOptionIdType } from '../types';

export const getNoticeFirstTitleById = (
  id: NoticeFirstOptionIdType | null | undefined,
): string | null => {
  if (!id) return null;
  return NOTICE_FIRST_OPTIONS.find((option) => option.id === id)?.title || null;
};

const DEFAULT: NoticeFirstOptionIdType = 'vibe';
export const getNoticeFirstIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): NoticeFirstOptionIdType | null => {
  const id = NOTICE_FIRST_OPTIONS.find((option) => option.title === title)?.id;
  if (id) {
    return id;
  }
  if (withDefault) {
    return DEFAULT;
  }
  return null;
};
